import ThemeSelector from "../settings/ThemeSelector";
import MenuContents from "./MenuContents";

// ---------------------- Component

const MenuFull = ({}) => {
  return (
    <div className="relative flex h-dvh w-screen flex-col items-center justify-start bg-white p-5 pt-5 dark:bg-gray-900 xs:p-8 sm:p-10 sm:pt-10">
      <div className="flex size-full max-w-[768px] flex-col justify-between">
        {/*******************************************/}
        {/* Menu Contents */}
        {/*******************************************/}

        <div>
          <MenuContents />
        </div>

        {/*******************************************/}
        {/* Theme Selector */}
        {/*******************************************/}

        <div className="mx-auto h-auto w-36">
          <ThemeSelector />
        </div>
      </div>
    </div>
  );
};

export default MenuFull;
